import script from "./CustomerInputBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerInputBlock.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerInputBlock.vue?vue&type=style&index=0&id=49c7b1ae&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c7b1ae"]])

export default __exports__